<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            
        </div>
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>System Permission <button *ngIf="this.mps.manageDataPermission([dataPermission.System_Permission_Add])" type="button" class="btn btn-success ml-2" [routerLink]="['/PermissionManagement/create-system-permission']">
                        Add New System Permission <i class="fa fa-plus" aria-hidden="true"></i>

                    </button></h5>
                 
                </div>
                <div class="card-body">
                    <table class="table">
                        <thead>
                            <tr>
                                <th *ngFor='let c of columns'>
                                    <div *ngIf="c.isSortable" (click)="sortBy(c.key)">
                                        {{c.title}}
                                        <i *ngIf="queryObject.sortBy===c.key" class="fa" [class.fa-sort-asc]="queryObject.isSortAsc" [class.fa-sort-desc]="!queryObject.isSortAsc"></i>
                                    </div>
                                    <div *ngIf="!c.isSortable">
                                        {{c.title}}
                                    </div>
                                </th>

                            </tr>
                        </thead>
                        <tbody *ngIf="systemPermissionList?.length;else no_data_temp">
                            <tr *ngFor="let item of systemPermissionList">
                                <td>
                                    {{item.id}}
                                </td>
                                {{item.name}}
                                <td>
                                    <div [innerHTML]="item.description"></div>

                                </td>
                                <td>
                                    {{item.headerCode}}
                                </td>
                                <td>
                                    {{item.code}}
                                </td>
                                <td>
                                    <!-- <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="cbStatus{{item.emailTemplateId}}" [checked]="item.active" #cbStatus (change)="changeEmailTemplateStatus(item.emailTemplateId);">
                                        <label class="custom-control-label" for="cbStatus{{item.emailTemplateId}}"></label>
                                    </div> -->

                                </td>
                                <td>
                                    <a *ngIf="this.mps.manageDataPermission([dataPermission.System_Permission_Edit])" routerLink="/PermissionManagement/create-system-permission/{{item.id}}" style="margin-right: 8px"><i class="fa fa-edit"
                                  style="font-size: 25px;color: rgb(10, 2, 116); cursor: pointer;"></i></a>

                                    <i *ngIf="this.mps.manageDataPermission([dataPermission.System_Permission_Delete])" (click)="onDeleteConfirm(item.id)" class="fa fa-trash" style="font-size: 25px; color: red;cursor: pointer;"></i>
                                </td>

                            </tr>
                        </tbody>
                        <ng-template #no_data_temp>
                          <h4 class="text-center d-block w-100 mt-3">{{this.noDataFound}}</h4>
                        </ng-template>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
